(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('clipArt', {
            parent: 'entity',
            url: '/clipArt?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'backApp.title.masking'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/clip-art/clip-art.html',
                    controller: 'ClipArtController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clipArt');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('clipArt.detail', {
            parent: 'clipArt',
            url: '/clipArt/{id}',
            data: {
                authorities: ["ROLE_CLIPART"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clip-art/clip-art-detail.html',
                    controller: 'ClipArtDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('clipArt');
                            return $translate.refresh();
                        }],
                        entity: ['ClipArt', function(ClipArt) {
                            return ClipArt.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('clipArt', {}, {
                        reload: false
                    });
                }, function() {
                    $state.go('clipArt');
                });
            }]
        })
        .state('clipArt.new', {
            parent: 'clipArt',
            url: '/new',
            data: {
                authorities: ["ROLE_CLIPART"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clip-art/clip-art-dialog.html',
                    controller: 'ClipArtDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {name: null, identifier: null, cancelled: null, provider: null, id: null,type:null};
                        }
                    }
                }).result.then(function() {
                    $state.go('clipArt', null, { reload: 'clipArt' });
                }, function() {
                    $state.go('clipArt');
                });
            }]
        })
        .state('clipArt.edit', {
            parent: 'clipArt',
            url: '/edit/{id}',
            data: {
                authorities: ["ROLE_CLIPART"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clip-art/clip-art-dialog.html',
                    controller: 'ClipArtDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('clipArt');
                            return $translate.refresh();
                        }],
                        entity: ['ClipArt', function(ClipArt) {
                            return ClipArt.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('clipArt', null, { reload: 'clipArt' });
                }, function() {
                    $state.go('clipArt');
                });
            }]
        });
    }

})();
